import React, { Component } from 'react';
import './main-page.css';
import AppPresentation from './app-presentation';
// import { BrowserRouter } from 'react-router-dom';

class App extends Component {
  state = {};

  componentWillMount() {
    this.fetchGuitars();
  }

  fetchGuitars = () => {
    fetch('/guitars.json')
      .then(rsp => rsp.json())
      .then(allGuitars => {
        this.allGuitars = allGuitars;
        this.determineFeaturedGuitar();
        this.determineUniqueBrands();
      });
  };

  determineFeaturedGuitar = () => {
    if (this.allGuitars) {
      const randomIndex = Math.floor(Math.random() * this.allGuitars.length);
      const featuredGuitar = this.allGuitars[randomIndex];
      this.setState({ featuredGuitar });
    }
  };

  determineUniqueBrands = () => {
    const brands = this.allGuitars
      ? Array.from(new Set(this.allGuitars.map(h => h.brand)))
      : [];
    brands.unshift(null);
    this.setState({ brands });
  };

  filterGuitars = brand => {
    this.setState({ activeGuitar: null });
    const filteredGuitars = this.allGuitars.filter(h => h.brand === brand);
    this.setState({ filteredGuitars });
    this.setState({ brand });
  };

  setActiveGuitar = guitar => {
    this.setState({ activeGuitar: guitar });
  };

  render() {
    return (
      <AppPresentation
        brand={this.state.brand}
        filteredGuitars={this.state.filteredGuitars}
        featuredGuitar={this.state.featuredGuitar}
        brands={this.state.brands}
        filterGuitars={this.filterGuitars}
        activeGuitar={this.state.activeGuitar}
        setActiveGuitar={this.setActiveGuitar}
      />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/main-page/index.js